import React from 'react';
import { getCookie } from '../utils/cookie';

export default function CustBlock ({MenuData}) {
	const setFrameHeight = (para) => {
		const tab = getCookie(setCurrMainTab);

		for (let i = 0; i < MenuData.length; i++) {
			if (MenuData[i].TabName.toLowerCase() == tab.toLowerCase()) {
				return {
					URL: MenuData[i].URL,
					Size: MenuData[i].Size
				};
			}
		}
	}

	const custSet = setFrameHeight();

	return (
		<div className="callbacks_container">
			<iframe
				id="custFrame"
				src={custSet.URL}
				width="1024"
				height={custSet.Size}
				frameBorder="0"
				scrolling="no"
				border="0"
				allowtransparency=""
			/>
		</div>
	);
}
